import React, { useEffect, useMemo, useState } from 'react'
import { Button, makeStyles, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle, Title1 } from '@fluentui/react-components'
import { t } from '../../i18n/i18n'
import { Loader } from '../common/spinner/Loader'
import { Fullscreen } from '../common/fullscreen/Fullscreen'
import { Text } from '../common/text/Text'
import { cancelAuth, mapUserMessage, startPolling } from '../../helpers/bankIdHelper'
import { QRCodeDisplay } from './QRCodeDisplay'
import { useAuth } from '../../context/AuthContext'
import { Dismiss20Regular } from '@fluentui/react-icons'
import { CollectAndAuthResponse } from '../../api/schemas/schema'
type BankIdQRProps = {
   sessionId: string
   clearSession: () => void
}
const useStyles = makeStyles({
   cancelBtn: {
      alignSelf: 'end',
   },
})
export const BankIdQR = ({ sessionId, clearSession }: BankIdQRProps) => {
   const [collectionData, setCollectionData] = useState<CollectAndAuthResponse>(null)
   const [error, setError] = useState<string>(null)
   const { login } = useAuth()
   const classes = useStyles()
   const userMessage: string = useMemo(() => {
      if (collectionData) {
         if (collectionData.status === 'complete') return t('SigningIn')
         else return mapUserMessage(collectionData.hintCode, collectionData.status)
      }
   }, [collectionData])

   useEffect(() => {
      if (sessionId) {
         startPolling(setCollectionData, setError, () => login('bankid'), clearSession, error, sessionId)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [sessionId])

   return (
      <Fullscreen>
         {({ enterFullscreen, exitFullscreen, isFullscreen }) => (
            <>
               <Button className={classes.cancelBtn} onClick={() => cancelAuth(clearSession, sessionId)} icon={<Dismiss20Regular />} appearance="transparent">
                  {t('Cancel')}
               </Button>
               <Title1 align="center" as="h2">
                  {t('SignInWithBankId')}
               </Title1>
               {error ? (
                  <MessageBar layout="auto" style={{ width: '100%' }} intent={'error'}>
                     <MessageBarBody>
                        <MessageBarTitle>{error}</MessageBarTitle>
                        <MessageBarActions>
                           <Button appearance="subtle" onClick={clearSession}>
                              {t('TryAgain')}
                           </Button>
                        </MessageBarActions>
                     </MessageBarBody>
                  </MessageBar>
               ) : (
                  <>
                     {!collectionData || (collectionData && (collectionData.hintCode === 'userSign' || collectionData.status === 'complete')) ? (
                        <Loader />
                     ) : (
                        <QRCodeDisplay
                           qrCodeValue={collectionData}
                           enterFullscreen={enterFullscreen}
                           exitFullscreen={exitFullscreen}
                           isFullscreen={isFullscreen}
                        />
                     )}
                     {userMessage && <Text align="center">{userMessage}</Text>}
                  </>
               )}
            </>
         )}
      </Fullscreen>
   )
}
